import * as ko from 'knockout';

import i18n from '../i18n';
import * as dmApi from '../api/dimension_metas';
import * as dimensionsApi from '../api/dimensions';
import { ImportEntitiesDelegate } from '../components/import_entities';
import { BaseLoadingScreen } from './base_loading_screen';
import { translate } from '../i18n_text';

const template = require('raw-loader!../../templates/components/import_entities_container.html').default;

class ImportDimensionStagesScreen extends BaseLoadingScreen implements ImportEntitiesDelegate<string[]> {
  title = ko.observable(i18n.t('Import stages')());
  description: string;
  backTitle = i18n.t('Back to list')();

  templateBaseName = 'import_stages';
  importUrl: string;

  private dmIdOrSlug: string;

  constructor(params: { dmIdOrSlug: string }) {
    super();

    this.dmIdOrSlug = params.dmIdOrSlug;
    this.importUrl = `/api/dimensions/${params.dmIdOrSlug}/import_stages/`;

    let promise = dmApi.retrieve(params.dmIdOrSlug).then((dm) => {
      const entityName = translate(dm.name_json);

      this.title(i18n.t('Import {{entityName}} stages', { entityName })());
      this.description = i18n.t(
        'To import {{entityName}} stages, download the Excel template, fill-in the desired records and then upload the file.',
        { entityName }
      )();
    });
    this.loadedAfter(promise);
  }

  downloadTemplate(): Promise<Blob> {
    return dimensionsApi.downloadStagesImportTemplate(this.dmIdOrSlug);
  }
}

export const importDimensionStages = {
  name: 'import-dimension-stages',
  viewModel: ImportDimensionStagesScreen,
  template,
};

ko.components.register(importDimensionStages.name, importDimensionStages);
